
import { Box } from '@mui/joy';
import { useRef, useEffect } from 'react';
import { useUpdateNodeInternals, useNodes } from '@xyflow/react';
import JSONPretty from 'react-json-pretty';
import { useFormatter, useString } from 'src/mtska-frontend-app-component/utils';
import { useTranslation } from 'react-i18next';

const DealNode = (props) => {
    const ref = useRef(null);
    const { formatDate } = useFormatter();
    const { t } = useTranslation();

    const { firstCharacter, toColor } = useString();

    return (
        <Box ref={ref} className="flow-node flow-node-deal">
            {/* <JSONPretty data={props.item} className='json-wrapper' /> */}
            <Box className="partner" style={{ backgroundColor: toColor(props.item.partner.name + props.item.partner.name) }}>{props.item.partner.name} {props.item.partner.logo}</Box>
            <Box className="title">{props.item.name}</Box>
            <Box className="dates">
                <Box className="start_at">{formatDate(props.item.start_at)}</Box>
                <Box className="end_at">{formatDate(props.item.end_at)}</Box>
            </Box>
            <Box className="priority">{props.item.siblingPriority}</Box>
            <Box className="rulesets">
                {
                    (props.item.rulesets ?? []).map((ruleset) => {
                        return <Box className="ruleset">
                            <Box className="production">{ruleset.production}</Box>
                            <Box className="rules">
                                {(ruleset.rules ?? []).map((rule) => {
                                    return <Box className="rule">
                                        <Box className="field">{t((rule.field ?? '').replace('_related_', '').replace('_readable', '').replace('_numeric', ''))}</Box>
                                        <Box className="operator">{t(rule.operator)}</Box>
                                        <Box className="value">{rule.value}</Box>
                                    </Box>
                                })}
                                {(ruleset.rules ?? []).length == 0 && <em>No rules</em>}
                            </Box>
                        </Box>
                    })
                }
            </Box>
        </Box>
    );
};

export default DealNode